import React from "react"
import { Helmet } from "react-helmet"
import SkewPlax from "../../components/SkewPlax/SkewPlax"
import SkewBg from "../../components/SkewBg/SkewBg"
import DetailTabs from "../../components/Stack/DetailTabs"
import BaseInfo from "../../components/BaseInfo/BaseInfo"
// import baseImage from "../../assets/images/hugo.jpg"
import Welcome from "./Welcome.js"
const classes = require('./Locations.module.scss')
const base = "Rosebud, South Dakota"
const baseShort = "Rosebud, SD"
const plaxContent = (<Welcome />)
const skewSub = (<h3>{base}</h3>)
const skewTitle1 = (<h4>Medical Air<br/> Rescue Company</h4>)
const baseInfo = (
  <div>
    <p><b>Base Lead </b><br/>Leslie Peterson</p>
    <p><b>Lead Pilot</b><br/>Larry Lukas</p>
    <div className={classes.clearfixBtn}/>
    <a 
      href="https://www.google.com/search?sca_esv=23368486d762886d&cs=0&sxsrf=ANbL-n5PF7nZkcq0NwadQZvdF3KpPl9iEw:1776858999779&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qOfq-v2--iWj_4quT-3-oAd8rtljLrMwMucaQv6y3rDECLDKyUV1ezbh0uS430499iY_nMRsKz_Kk1Pm9zWrtL6XsabHmwhi0zDat-vkSp32oP6r0iA%3D%3D&q=Medical+Air+Rescue+Co+-+Rosebud+Reviews&sa=X&ved=2ahUKEwjHtv3Ls4GUAxVJNt4AHe7JOhEQ0bkNegQIJRAH&biw=1728&bih=992&dpr=2#lrd=0x8778b39ce17ee039:0x199d78921e1d668d,3,,,," 
      target="_blank" 
      rel="noreferrer"
      title={`Write a review for MARC's ${baseShort} base`}
      className={classes.marcLinkSm}>
      Leave a Review</a>
  </div>
)

const rosebud = () => {
  return (
    <div className={[classes.LocationsPage, classes.Rosebud].join(' ')}>
      <Helmet>
        <title>{baseShort} Base | Medical Air Rescue Company</title>
        <meta name="description" content="Medical Air Rescue Company provides safe, reliable medical air transport across the contenintal U.S. We also love serving our local community in Rosebud, SD." />
      </Helmet>

      <SkewPlax content={plaxContent} spClass="tall" addClass="Bases" />
      <SkewBg skewStyle="BaseStack" title={skewTitle1} stackSub={skewSub} addClass="rosebudStack" />

      <BaseInfo baseClass="Rosebud" base={base} baseDetails={baseInfo} />
      <DetailTabs where="bases" classless="baseTabs" headline="One Life. One Mission. Every Time." />
    </div>
  )
}
export default rosebud